<template>
	<div class="text-center">
		<v-dialog
			v-if="internalShow"
			v-model="show"
			width="600"
			persistent
			@input="(v) => v || closeModal()"
			content-class="create-thread-modal overflow-x-hidden"
		>
			<v-card class="create-thread-modal__card">
				<div class="create-thread-modal__card__closes">
					<v-icon class="justify-end" style="cursor: pointer" @click="closeModal"
						>mdi-close</v-icon
					>
				</div>

				<div class="d-flex justify-space-between align-center flex-wrap">
					<div class="create-thread-modal__title">
						{{ edit ? 'Edit' : 'Create' }} Post
					</div>
				</div>

				<v-tabs v-model="tab" class="create-thread-modal__tabs-wrapper">
					<v-tab class="modal_title">Text</v-tab>
				</v-tabs>

				<v-tabs-items v-model="tab">
					<v-tab-item>
						<PostForumTextForm
							v-on:closeModal="closeModal"
							:activeTab="tab"
							:categoryId="categoryId"
							:showForm="show"
							:edit="edit"
							:editableForum="editableForum"
						/>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PostForumTextForm from '@/components/Forms/PostForumTextForm.vue'
export default {
	components: { PostForumTextForm },

	props: {
		show: {
			type: Boolean,
			default: false,
		},
		categoryId: {
			type: Number,
			default: null,
		},
		edit: {
			type: Boolean,
			default: false,
		},
		editableForum: {
			type: Object,
			default: () => ({}),
		},
	},

	data: () => ({
		tab: null,
		internalShow: false,
	}),

	methods: {
		...mapActions('chats', ['deleteMessage']),
		...mapActions('settings', ['fetchChapters', 'getAppCoreSettings']),
		...mapActions('forum', ['fetchForumCategories', 'deleteChosenCategory', 'chosenCategory']),

		closeModal() {
			this.deleteChosenCategory()
			this.$emit('closeModal')
		},

		getCurrentDate() {
			const date = new Date()

			return `${
				date.getMonth() + 1
			}/${date.getDate()}/${date.getFullYear()}, ${this.formatTime(date)}`
		},

		// Function to format the time in 12-hour format with AM/PM
		formatTime(date) {
			let hours = date.getHours()
			let minutes = date.getMinutes()
			const ampm = hours >= 12 ? 'pm' : 'am'
			hours %= 12
			hours = hours || 12 // Handle midnight (0 hours)
			minutes = minutes < 10 ? `0${minutes}` : minutes
			return `${hours}:${minutes} ${ampm}`
		},
	},

	computed: {
		...mapGetters('settings', ['chaptersList']),
		...mapGetters('forum', ['forumCategories']),
		...mapGetters('post', ['isFileLoading', 'postFile']),
		...mapGetters('tag', ['tags']),
	},

	watch: {
		show: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					setTimeout(() => {
						this.internalShow = true
					}, 0)
				} else {
					this.internalShow = false
				}
			},
		},
		forumCategories() {
			if (this.$props.categoryId) {
				this.chosenCategory(this.$props.categoryId)
			}
		},
	},

	created() {
		if (this.$props.categoryId) {
			this.chosenCategory(this.$props.categoryId)
		}

		if (this.forumCategories.length <= 0) {
			this.fetchForumCategories()
		}
	},
}
</script>

<style lang="scss">
.modal_title {
	margin-left: -15px !important;
	margin-bottom: -15px !important;
	width: 37px !important;
	font-family: 'Montserrat', sans-serif !important;
	font-weight: 700 !important;
	font-size: 14px !important;
	line-height: 17.07px !important;
	text-align: center !important;
}
.create-thread-modal {
	border-radius: 13px;
	max-height: 800px !important;
	overflow: visible !important;

	&__card {
		padding: 35px;
		position: relative;
		&__closes {
			position: absolute;
			top: 8px;
			right: 8px;
		}
	}
	&__title {
		color: #4a4a4a;
		font-size: 24px !important;
		font-family: 'Inter', sans-serif !important;
		font-weight: 700 !important;
		line-height: 29.26px !important;
	}
	&__time {
		color: rgb(74, 74, 74);
		font-size: 12px;
		font-family: 'Inter', sans-serif;
		font-weight: 600;
		letter-spacing: -0.29px;
		padding: 10px 0;
	}
	&__tabs-wrapper {
		padding-bottom: 5px;
		margin-top: 5px;
		padding-right: 28px;
		font-weight: 400 !important;
		font-size: 14px !important;

		.v-slide-group__wrapper {
			border-bottom: 1px solid rgb(219, 219, 219);
		}
		.v-tabs-slider {
			width: 75px;
		}
	}
}
</style>
